import ReactDOM from "react-dom";
import React from "react";
import ViewStackRegion from "lib/viewstackregion/ViewStackRegion";
import { BackboneNavbarView as NavbarView } from "./NavbarView";

class AppLayout extends Backbone.Marionette.Layout {

    constructor(...args) {
        super(...args);
        this.showModal = this.showModal.bind(this);
        this.initialize = this.initialize.bind(this);
        this.onRender = this.onRender.bind(this);
    }

    initialize(options){
        this.appModel = options.appModel;
        this.listenTo(this.modal, "show", () =>
            //  Cause the modal's div to become visible.
            $("body").addClass("modal-open")
        );
        this.listenTo(this.modal, "region:close", () => $("body").removeClass("modal-open"));
    }

    // I use the passed view factory function to render a modal, and return a
    // promise which will resolve when the modal is popped off the stack. The
    // factory function may be invoked multiple times, if another modal is
    // rendered atop it, but the promise will only resolve when the modal is
    // popped off the stack (not hidden).
    showModal(viewFn) {
        return new Promise(resolve => {
            const onPop = vfn => {
                if (vfn !== viewFn) {
                    return;
                }
                this.stopListening(this.modal, "region:pop", onPop);
                resolve();
            };
            this.listenTo(this.modal, "region:pop", onPop);
            this.modal.showOnStack(viewFn);
        });
    }

    onRender() {
        ReactDOM.render(
            <NavbarView appModel={this.appModel} />,
            document.getElementById("global-navbar"));
    }

}

AppLayout.prototype.template = require("views/templates/appLayout");
AppLayout.prototype.el = "body";

AppLayout.prototype.regions = {
    de: "#content_de",
    hex: "#content_hex",
    modal: {
        selector: "#modal",
        regionType: ViewStackRegion
    }
};

AppLayout.prototype.events = {};

export default AppLayout;



// WEBPACK FOOTER //
// ./app/views/AppLayout.js